import $ from 'jquery';

class cdpInsightProfilesWithPrizehunter{
  constructor() {
    if ($('#cdp-insight-profiles-with-prizehunter').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-insight-profiles-with-prizehunter').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    $('#cdp-insight-profiles-with-prizehunter .card-body .card-body h4').text(this.transform(response.profiles_count));
    $('#cdp-insight-profiles-with-prizehunter .card-body .card-text').html(`С большой вероятностью, <b>${this.transform(response.profiles_count)}</b> участников можно отнести к призоловам.`);
    $('#cdp-insight-profiles-with-prizehunter .peity-donut').text(`${response.profiles_percentage}/100`);
    $('#cdp-insight-profiles-with-prizehunter .peity-donut').peity('donut');
    this.loaded();
    this.toggleActionBtn(response.profiles_count);
  }

  toggleActionBtn(profiles_count){
    if (profiles_count > 0){
      $('#cdp-insight-profiles-with-prizehunter .open-new-insight-segment-modal').removeClass('d-none');
    } else {
      $('#cdp-insight-profiles-with-prizehunter .open-new-insight-segment-modal').addClass('d-none');
    }
  }

  loading(){
    $('#cdp-insight-profiles-with-prizehunter').addClass('loading');
  }

  loaded(){
    $('#cdp-insight-profiles-with-prizehunter').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpInsightProfilesWithPrizehunter;